namespace GeniuzPOS.Product {
    export interface CsPluRow {
        Id?: number;
        SkuCode?: string;
        PluCode?: string;
        PluDesc?: string;
        PluShortDesc?: string;
        StyleId?: string;
        StyleName?: string;
        ColorId?: string;
        ColorName?: string;
        SizeId?: string;
        SizeName?: string;
        TasteId?: string;
        TasteName?: string;
        MatTypeId?: string;
        MatTypeName?: string;
        SellUnit?: string;
        SellUnitRatio?: number;
        SellUnitPrice1?: number;
        SellUnitPrice2?: number;
        SellUnitPrice3?: number;
        SellUnitPrice4?: number;
        SellUnitPrice5?: number;
        SellUnitPrice6?: number;
        DeliverCost?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        SkuDesc?: string;
        PluName?: string;
        PluType?: number;
        ConceptCode?: string;
        ActiveSellFg?: number;
        ActiveRepFg?: number;
        IsActive?: number;
    }

    export namespace CsPluRow {
        export const idProperty = 'PluCode';
        export const nameProperty = 'PluName';
        export const localTextPrefix = 'Product.CsPlu';
        export const lookupKey = 'Product.CsPlu';

        export function getLookup(): Q.Lookup<CsPluRow> {
            return Q.getLookup<CsPluRow>('Product.CsPlu');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            PluDesc = "PluDesc",
            PluShortDesc = "PluShortDesc",
            StyleId = "StyleId",
            StyleName = "StyleName",
            ColorId = "ColorId",
            ColorName = "ColorName",
            SizeId = "SizeId",
            SizeName = "SizeName",
            TasteId = "TasteId",
            TasteName = "TasteName",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            SellUnit = "SellUnit",
            SellUnitRatio = "SellUnitRatio",
            SellUnitPrice1 = "SellUnitPrice1",
            SellUnitPrice2 = "SellUnitPrice2",
            SellUnitPrice3 = "SellUnitPrice3",
            SellUnitPrice4 = "SellUnitPrice4",
            SellUnitPrice5 = "SellUnitPrice5",
            SellUnitPrice6 = "SellUnitPrice6",
            DeliverCost = "DeliverCost",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            SkuDesc = "SkuDesc",
            PluName = "PluName",
            PluType = "PluType",
            ConceptCode = "ConceptCode",
            ActiveSellFg = "ActiveSellFg",
            ActiveRepFg = "ActiveRepFg",
            IsActive = "IsActive"
        }
    }
}
